<!-- REF: 15.7 -->
<template>
  <gv-modal
    data-theme="mobile"
    :modal="modal"
    size="custom"
    :custom-size-class="tw`w-[calc(100vw-2rem)] xs:w-[480px] pb-10`"
    layout="flex-col"
    :close-on-click-outside="false"
    :border-radius="tw`rounded-2xl`"
  >
    <template #header>
      <div class="flex items-center pl-2 pt-2">
        <div class="flex size-10 items-center justify-center">
          <!-- TODO: Refactor to use Mep button -->
          <gv-button variant="text" scheme="custom" size="custom" type="button" @click.stop="modal.setClosed">
            <gv-icon name="close" aria-label="Close" size="md" class="fill-surface-variant-on" />
          </gv-button>
        </div>
      </div>
    </template>

    <div class="flex flex-col gap-4 px-10">
      <mep-type variant="feature-large">People who may need assistance or extra support with emergency planning include:</mep-type>
      <ul class="ml-1 grow list-inside list-disc">
        <li>Babies, children and young people</li>
        <li>A person who is unwell, injured, elderly or frail</li>
        <li>Visitors who are not familiar with the local area</li>
        <li>A person with a cognitive or physical disability</li>
        <li>A person who can’t understand or read English</li>
        <li>A person with mental health concerns</li>
      </ul>
    </div>
  </gv-modal>
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import * as Symbols from '@/common/constants/symbols';
import { tw } from '@/common';

const { modal } = {
  modal: inject(Symbols.MyEmergencyPlanHigherRiskPeopleModal)!,
};
</script>
